import React, { lazy, Suspense } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import LoadingStatus from '@paycor/pds-loading-status';
import { RouteUrls } from 'constants/routeUrls';
import ScrollToTopRoute from 'components/ScrollToTopRoute';
import { useTranslation } from 'react-i18next';
import { getTranslatedText } from 'utils/i18n';

const PageNotFound = lazy(() => import('components/PageNotFound'));
const Forbidden = lazy(() => import('pages/Forbidden'));
const Home = lazy(() => import('pages/Home'));
const Activate = lazy(() => import('pages/Activate'));
const ActivateClient = lazy(() => import('pages/Activate/Clients'));
const ActivateConfirm = lazy(() => import('pages/Activate/Confirm'));
const AuthorizePage = lazy(() => import('pages/Authorize'));
const ClientActivation = lazy(() => import('pages/ClientActivation'));
const ClientRedirect = lazy(() => import('pages/ClientRedirect'));
const ActivateUsers = lazy(() => import('pages/UserActivation'));

export default () => {
	const { t } = useTranslation();
	const { PAGE_NOT_FOUND, HOME, HOME_APP, FORBIDDEN, AUTHORIZE, ACTIVATE, ACTIVATE_CLIENT, ACTIVATE_CONFIRM, CLIENTACTIVATION, CLIENTREDIRECT, ACTIVATE_USERS } = RouteUrls;
	return (
		<Suspense fallback={<LoadingStatus loadingMessage={getTranslatedText(t, 'Loading')}/>}>
			<Switch>
				<ScrollToTopRoute path={HOME} exact component={Home} />
				<ScrollToTopRoute path={HOME_APP} exact component={Home} />
				<ScrollToTopRoute path={PAGE_NOT_FOUND} exact component={PageNotFound} />
				<ScrollToTopRoute path={FORBIDDEN} component={Forbidden} />
				<ScrollToTopRoute path={ACTIVATE} component={Activate} />
				<ScrollToTopRoute path={ACTIVATE_CLIENT} component={ActivateClient} />
				<ScrollToTopRoute path={ACTIVATE_CONFIRM} component={ActivateConfirm} />
				<ScrollToTopRoute path={AUTHORIZE} component={AuthorizePage} />
				<ScrollToTopRoute path={CLIENTACTIVATION} component={ClientActivation} />
				<ScrollToTopRoute path={CLIENTREDIRECT} component={ClientRedirect} />
				<ScrollToTopRoute path={ACTIVATE_USERS} component={ActivateUsers} />
				<Redirect to={PAGE_NOT_FOUND} />
			</Switch>
		</Suspense>
	);
};
